<template>
    <div v-if="tempProposal.locked && locked">
        <!-- Modal -->
        <div id="signAndAccept" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Send for Signing</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-4">Enter your name as you would like it to appear on the agreement</div>
                            <div class="form-group">
                                <label :class="{'text-red': form.errors.has('signed_name')}">Full Name</label>
                                <input v-model="form.signed_name" class="form-control"
                                       :class="{'border-red': form.errors.has('signed_name')}" type="text">
                                <div class="text-red text-xs" v-if="form.errors.has('signed_name')">
                                    {{ form.errors.get('signed_name') }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label :class="{'text-red': form.errors.has('email_at_signing')}">Email</label>
                                <input v-model="form.email_at_signing" class="form-control"
                                       :class="{'border-red': form.errors.has('email_at_signing')}" type="text">
                                <div class="text-red text-xs" v-if="form.errors.has('email_at_signing')">
                                    {{ form.errors.get('email_at_signing') }}
                                </div>
                            </div>
                            <input v-model="form.i_agree" class="mr-2" type="checkbox">
                            <span>
                                I agree that the signature will be the electronic representation of my signature for all purposes when I (or my agent) use
                                them on documents, inluding legally binding documents, just the same as pen-and-paper signature.
                            </span>
                            <div v-if="form.errors.has('i_agree')" class="text-red text-xs">
                                You must agree to the condition.
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="signAndAccept"
                                class="btn btn-outline-primary rounded-full">
                            Sign Quote
                        </button>
                    </div>
                </div>
            </div>
        </div>

<!--        <div class="mb-4 text-right">-->
<!--            <button @click.prevent="openSignAndAcceptModal(proposal)"-->
<!--                    class="btn btn-outline-primary rounded-full">-->
<!--                Sign & Accept-->
<!--            </button>-->
<!--        </div>-->
        <!-- <object :data="'https://drive.google.com/viewerng/viewer?embedded=true&url='+pdf" type="application/pdf" frameborder="0" width="100%" height="900px">
            <embed :src="'https://drive.google.com/viewerng/viewer?embedded=true&url='+pdf" width="100%" height="900px"/>
        </object> -->

        <iframe style="width: 100%; height:100vh" :src="pdf+'#view=FitH'" ></iframe>
    </div>
    <div v-else class="flex justify-center mt-24">

        <img width="600" src="/images/working.svg">
    </div>

</template>

<script>
    import Form    from "../../utils/form";
    import Swal    from 'sweetalert2';
    import Preview from "./preview/preview";

    export default {
        components: {Preview},
        props: ['proposal', 'signer', 'team', 'pdf'],
        data() {
            return {
                tempProposal: this.proposal,
                form: new Form({
                    proposalToken: this.proposal.token,
                    signerToken: this.signer.token,
                    signed_name: null,
                    email_at_signing:null,
                    i_agree: false,
                    client_ip:''
                }),
                locked: true,
                docEditor: null,
                editorConnectors: null,
                documentKey: null,
                onlyOfficeCallBackUrl: window.location.origin+"/only-office-callback/"+this.proposal.id+'/text',
            }
        },
        mounted() {
            if (!this.tempProposal.locked) {
                this.fireErrorToast('The quote has been locked. The quote is currently \n ' +
                    'being modified and cannot be signed at this time. Please check back at a later \n ' +
                    'time to sign your quote. Thank you for your patience!');
            }
            this.getIPFromAmazon();
        },
        methods: {
            openSignAndAcceptModal() {
                if(this.form.signerToken == null){
                    this.fireErrorToast('Please login to sign and accept the proposal.');
                    setTimeout(function(){ window.location.href = "/login"; },5000);
                    return false;
                }
                $("#signAndAccept").modal("show");
            },
            signAndAccept() {
                let self = this;
                this.form.post('/proposal/sign-and-accept')
                    .then((response) => {
                        if (response.status === 'success') {
                            $("#signAndAccept").modal("hide");
                            window.location = response.redirect;
                        } else {
                            $("#signAndAccept").modal("hide");
                            self.fireErrorToast(response.message);
                            self.locked = false;
                        }
                    });
            },
            fireErrorToast(message) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                });

                Toast.fire({
                    type: 'warning',
                    title: message,
                });
            },
            getIPFromAmazon() {
                fetch('https://api.ipify.org?format=json')
                    .then(x => x.json())
                    .then(({ ip }) => {
                        this.form.client_ip = ip;
                        this.updateProposalOpen();
                    });
            },
            updateProposalOpen(){
                axios.post('update-proposal-open', {proposal: this.proposal.id, ip:this.form.client_ip});
            }
        },
    }
</script>

<style scoped>
    .reports-frame-style {
        height: 100vh;
        width: 100%;
        border: 1px solid grey;
        border-radius: 7px;
    }
</style>
